const API = process.env.REACT_APP_API_URL;

const ROUTE_MAP: Array<{ re: RegExp; mint: string; render: string }> = [
  { re: /\/estimate-pdf\/(\d+)/, mint: "generate-pdf-token/estimate", render: "estimate-pdf1" },
  { re: /\/po-pdf\/(\d+)/, mint: "generate-pdf-token/po", render: "po-pdf2" },
  { re: /\/po-delivery-challan\/(\d+)/, mint: "generate-pdf-token/po", render: "po-delivery-challan2" },
];

export const buildSharablePdfUrl = async (rawUrl: string): Promise<string> => {
  const [pathPart, query = ""] = rawUrl.split("?");
  const route = ROUTE_MAP.find((r) => r.re.test(pathPart));
  if (!route) return rawUrl;
  const id = pathPart.match(route.re)![1];
  const res = await fetch(`${API}/${route.mint}/${id}/`, {
    headers: { Authorization: `JWT ${localStorage.getItem("token")}` },
  });
  if (!res.ok) throw new Error(`PDF link generation failed: ${res.status}`);
  const { encrypted_token } = await res.json();
  return `${API}/${route.render}/${encrypted_token}/${query ? `?${query}` : ""}`;
};

export const openAuthedPdf = async (rawUrl: string) => {
  window.open(await buildSharablePdfUrl(rawUrl), "_blank");
};
